import { call, put } from "redux-saga/effects";

import { extractErrorMessage } from "../../../api";
import { fetchLearnerModulesApi } from "../../services/learnerModulesApi";
import {
    fetchLearnerModulesFail,
    fetchLearnerModulesSuccess,
    setLearnerModulesLoading,
} from "../actions/learnerModulesActions";

export function* fetchLearnerModulesSaga() {
    yield put(setLearnerModulesLoading(true));
    try {
        const response = yield call(fetchLearnerModulesApi);
        yield put(fetchLearnerModulesSuccess(response.data || []));
    } catch (error) {
        yield put(fetchLearnerModulesFail(extractErrorMessage(error, "Impossible de charger vos modules.")));
    } finally {
        yield put(setLearnerModulesLoading(false));
    }
}
